export const TOLGEE_KEYS = {
  description: ({ searchFilter }: { searchFilter: string }) => ({
    key: 'ButtonSearchRedirectVideoTopic-textDescription',
    parameters: {
      searchFilter,
      strong: <strong />,
    },
    defaultValue: `Não encontramos o tópico <strong>"{searchFilter}"</strong>, você pode`,
  }),
  button: {
    key: 'ButtonSearchRedirectVideoTopic-button',
    defaultValue: 'ver um tópico criado com vídeos com este termo',
  },
  errorToast: {
    key: `ButtonSearchRedirectVideoTopic-toastLimitMessageOwnedTopic`,
    defaultValue:
      'Você atingiu o limite do seu plano. Faça um upgrade do plano para salvar mais tópicos próprios, ou exclua alguns dos seus tópicos salvos.',
  },
}
